<!-- #737 Tab „Zustellungen": Filterzeile -> Zeilen -> Mehr laden. Titelzeile, Brotkrume und
     Tab-Leiste haelt der Container; hier steht nur der Tab-Inhalt. -->
<div>

  <!-- Der Requeue-Knopf sitzt in der Filterzeile, nicht in der Titelzeile: sein Filter IST der
       Listenfilter. Stuende er oben, muesste der Container in den Zustand dieses Tabs greifen.
       Genau EINE Aktion, deshalb ohne [menuItems]: bei nicht-leerem menuItems feuert weder
       (clicked) noch (click) (default-button.component.ts:150). -->
  <div class="flex flex-col lg:flex-row px-[0.75rem] py-[0.4rem] leading-[1rem] bg-white gap-2">
    <div class="flex flex-row flex-wrap gap-2 lg:flex-1">

      <!-- Empfaenger: der wichtigste Filter. Nimmt serverseitig eine UUID — ein Support-Mitarbeiter
           kennt aber einen Namen, deshalb Auswahl mit Suche statt UUID-Textfeld. -->
      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="true"
        [filterBy]="'displayName'"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="recipientUserId()"
        [options]="usersValue()"
        [optionValue]="'id'"
        optionLabel="displayName"
        [placeholder]="'core.notificationDiagnostics.filters.recipient' | translate"
        (onChange)="onRecipientChange($any($event).value)"
        (onClear)="onRecipientChange(null)">
      </nx-filter-dropdown>

      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="false"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="channel()"
        [options]="channelOptions | arrayTranslate"
        [optionValue]="'value'"
        optionLabel="label"
        [placeholder]="'core.notificationDiagnostics.filters.channel' | translate"
        (onChange)="onChannelChange($any($event).value)"
        (onClear)="onChannelChange(null)">
      </nx-filter-dropdown>

      <!-- Status: Werte sind exakt die Enum-Namen, DeliveryStatus.valueOf(status) ist
           case-sensitiv. Freie Texteingabe waere eine Fehlerquelle. -->
      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="false"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="status()"
        [options]="statusOptions | arrayTranslate"
        [optionValue]="'value'"
        optionLabel="label"
        [placeholder]="'core.notificationDiagnostics.filters.status' | translate"
        (onChange)="onStatusChange($any($event).value)"
        (onClear)="onStatusChange(null)">
      </nx-filter-dropdown>

      <!-- Typ: Optionen aus dem Katalog (#735-Query). label kommt fertig uebersetzt vom Server,
           deshalb KEIN arrayTranslate. -->
      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="true"
        [filterBy]="'label'"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="typeKey()"
        [options]="typeOptionsValue()"
        [optionValue]="'value'"
        optionLabel="label"
        [placeholder]="'core.notificationDiagnostics.filters.type' | translate"
        (onChange)="onTypeKeyChange($any($event).value)"
        (onClear)="onTypeKeyChange(null)">
      </nx-filter-dropdown>

      <!-- Zeitraum: liefert bereits ISO-8601-Instants mit Z (toISOString), genau was Instant.parse
           erwartet. Gefiltert wird auf createdAt, nicht auf sentAt. includeOverDue bleibt ungenutzt. -->
      <nx-filter-date-select
        [className]="'table-filter'"
        [placeholder]="'core.notificationDiagnostics.filters.period' | translate"
        [showIncludeOverDue]="false"
        [ngModel]="dateRange()"
        (onChange)="onDateRangeChange($any($event))"
        (onClear)="onDateRangeChange(null)"
        optionLabel="label">
      </nx-filter-date-select>
    </div>
    <div class="flex flex-row items-center shrink-0">
      <nx-default-button
        [style]="'light'"
        [disabled]="requeueing()"
        (click)="onRequeue()"
        [label]="'core.notificationDiagnostics.requeue.buttonLabel'">
      </nx-default-button>
    </div>
  </div>

  <!-- Pruefreihenfolge ist verbindlich: error() VOR loading(). Bei HTTP 200 + errors[] koennen beide
       gleichzeitig wahr sein — wer loading() zuerst prueft, sieht ewig einen Spinner und nie die
       Fehlerzeile. Muster notification-settings-list.component.html:8-22. -->
  <!-- border-t auf jedem Zustandsblock: die Linie trennt Filterzeile und Inhalt. Die Linie der
       Tableiste sitzt eine Ebene hoeher, ueber der Filterzeile, und ersetzt diese hier nicht.
       Im Nachrichten-Tab uebernimmt die Kopfzeile der Kanalspalten dieselbe Aufgabe. -->
  @if (error()) {
    <div class="bg-white px-5 py-4 text-[#c0123c] border-t border-gray">
      {{ 'core.notificationDiagnostics.loadErrorMessage' | translate }}
    </div>
  } @else if (loading()) {
    <div class="bg-white px-5 py-4 flex flex-row justify-center border-t border-gray">
      <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
    </div>
  } @else if (items().length === 0) {
    <nx-empty-box
      class="border-t border-gray"
      [label]="'core.notificationDiagnostics.emptyMessage'">
    </nx-empty-box>
  } @else {
    <div class="border-t border-gray">
      @for (entry of items(); track entry.id) {
        <div
          notification-delivery-row
          [entry]="entry"
          [recipientName]="recipientName(entry.recipientUserId)">
        </div>
      }
    </div>

    <!-- Keine Seitenzahlen und KEINE Gesamtzahl: die API liefert bewusst kein totalCount, und
         items().length ist keine. Das Ende der Liste sagt ausschliesslich nextCursor === null. -->
    @if (hasMore()) {
      <nx-default-button
        class="block mt-2"
        [style]="'light'"
        [width]="'full'"
        [disabled]="loadingMore()"
        (click)="loadMore()"
        [label]="loadingMore() ? 'core.notificationDiagnostics.loadingMore' : 'core.notificationDiagnostics.loadMore'">
      </nx-default-button>
    }
  }
</div>
